import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-events-new',
  templateUrl: './events-new.component.html',
  styleUrls: ['./events-new.component.scss']
})
export class EventsNewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
